export default __webpack_public_path__ + "static/media/julia.e001e99c.png";